/** @jsxImportSource @emotion/react */
interface ModalProps {
  display: boolean;
  zIndex?: number;
  onHide: () => void | Promise<void>;
  children?: React.JSX.Element | string | (React.JSX.Element | string)[];
  className?: string;
}

const styles = {
  background: (option: Partial<{
    zIndex: number;
  }>) => ({
    position: "fixed" as const,
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh !important",
    backgroundColor: "#00000044",
    "z-index": `${option.zIndex || 100}`,
    "&:not([data-active=\"1\"])": {
      display: "none",
    },
  }),
  modal: {
    position: "fixed" as const,
    left: "50%",
    top: "50%",
    transform: "translateX(-50%) translateY(-50%)",
    padding: "2rem",
    backgroundColor: "#ffffff",
    borderRadius: "1rem",
    boxShadow: "0 0.2rem 0.4rem #00000088",
  },
};

const Modal = (props: ModalProps) => (
  <div
    data-active={props.display ? "1" : "0"}
    onClick={() => props.onHide()}
    css={styles.background({ zIndex: props.zIndex })}
  >
    <div
      onClick={(event) => event.stopPropagation()}
      css={styles.modal}
      className={props.className}
    >
      {props.children}
    </div>
  </div>
);

export { Modal };
